import {store} from '../store'
import { setToast } from '../store/toast'
export default function showToast(message,severity="success"){
    store.dispatch(setToast({message,severity,show:true}))
}